"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedsalon = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 54 52",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedsalon` : '') + (description ? ` desc-brandedsalon` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedsalon"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedsalon"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.1 48.1c-1.16 0-2.1-1.57-2.1-3.49V22.5c0-1.92.94-3.49 2.1-3.49 1.16 0 2.1 1.57 2.1 3.49v22.1c0 1.92-.93 3.5-2.1 3.5Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.23 51.87H13.78c-.8 0-1.47-.52-1.7-1.34-.23-.8.06-1.63.74-2.08l9.4-6.28c.28-.19.61-.29.95-.29h7.66c.34 0 .67.1.95.3l9.4 6.27c.68.45.97 1.27.74 2.08-.23.82-.9 1.35-1.7 1.35h.01Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.51 32.84h-1.29A6.59 6.59 0 0 1 3.6 26.3v-.76h2.64v.76a3.96 3.96 0 0 0 3.98 3.93h1.29v2.61Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.75 32.48h-1.3v-2.6h1.3c2.2 0 3.98-1.77 3.98-3.94v-.76h2.63v.76c0 3.6-2.96 6.54-6.61 6.54Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M.8 18.9c0-2.15 1.79-3.9 4-3.9s4 1.75 4 3.9V27h-8v-8.1Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M45.3 18.9c0-2.15 1.79-3.9 4-3.9s4 1.75 4 3.9V27h-8v-8.1Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.76 35H13.24c-1.8 0-3.24-1.57-3.24-3.5s1.45-3.5 3.24-3.5h27.52c1.8 0 3.24 1.57 3.24 3.5S42.55 35 40.76 35Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.33 1.6c-2.26.1-7.28-.69-11.5-1.47A4.05 4.05 0 0 0 11 4.03v17.05A3.95 3.95 0 0 0 14.98 25h24.04c2.2 0 3.98-1.75 3.98-3.92V3.95c0-2.47-2.3-4.32-4.76-3.89-4.02.32-8.67 1.46-10.9 1.55Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.07.15c-.88-.4-3.66.06-6.74.56-2.47.4-5.33.83-6 .85-2.27.1-7.27-.69-11.48-1.47A4.05 4.05 0 0 0 11.03 4v16.13c-.32 3.6 2.34 4.85 3.47 4.88C23.6 20.02 34.32 8.67 40.08.15Z",
    fill: "#F8985A"
  }));
};
var _default = exports.default = brandedsalon;